var _desc, _defs, _rect, _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSasLogoCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "33px",
    viewBox: "0 0 116 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "328B1C76-C2B1-4ACB-90D3-0EC8B186120B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.8053822%",
    y1: "4.54212398%",
    x2: "30.5996141%",
    y2: "89.1887703%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA05",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA05",
    offset: "3.01724%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC008",
    offset: "21.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A60F",
    offset: "53.73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07B1B",
    offset: "94.51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE771C",
    offset: "97.81%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.2404597%",
    y1: "2.05557683%",
    x2: "35.4203409%",
    y2: "88.4910962%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC1C24",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31C23",
    offset: "21.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB1C22",
    offset: "57.79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A61C20",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.6109487%",
    y1: "22.7732125%",
    x2: "33.18346%",
    y2: "96.8617825%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#049FDC",
    offset: "15.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7AAC",
    offset: "47.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20405F",
    offset: "91.31%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24344F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.1327109%",
    y1: "31.3740393%",
    x2: "66.1068361%",
    y2: "71.5941076%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808184",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858689",
    stopOpacity: 0.8789,
    offset: "12.11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E9093",
    stopOpacity: 0.4877,
    offset: "51.23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919396",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pager",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pager---New-Style",
    transform: "translate(-131.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quickheader",
    transform: "translate(0.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(108.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 159,
    height: 58.725
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(44.606335, 11.745000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.431674208,
    y: 0.4404375,
    width: 38.8506787,
    height: 33.47325
  }), /*#__PURE__*/React.createElement("text", {
    id: "Supplementary-Alerti",
    className: "logoText",
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontSize: 9.51117283,
    fontWeight: 500,
    "line-spacing": 8.64652075,
    letterSpacing: 0.223792306,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14.2452489,
    y: 17.5305417
  }, "SUPPLEMENTARY"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.2452489,
    y: 26.1770625
  }, "ALERTING SERVICE")), /*#__PURE__*/React.createElement("line", {
    x1: 7.33846154,
    y1: 10.1300625,
    x2: 7.33846154,
    y2: 25.0008497,
    id: "Line",
    className: "logoStroke",
    stroke: "#FFFFFF",
    strokeWidth: 0.864652075,
    strokeLinecap: "square"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Untitled-1",
    transform: "translate(23.742081, 12.479062)",
    fillRule: "nonzero"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50272786,14.974875 C5.19242405,12.156075 7.96747253,8.56965536 8.7691532,7.53777321 C8.88015514,7.39935 8.95415643,7.29867857 8.99115708,7.23575893 C9.64483516,6.36746786 10.606852,5.13424286 11.6305365,3.83809821 C12.0622107,3.29698929 12.3952165,2.88171964 12.8145572,2.34061071 C13.3819005,1.62332679 14.6399224,0.0125839286 14.6399224,0.0125839286 L10.7918552,0.0125839286 C10.7918552,0.0125839286 8.30047835,2.94463929 5.73510019,6.46813929 C3.33005818,9.7777125 1.12235294,12.8230232 0.320672269,16.031925 C0.123335488,16.8498804 0.0493341952,17.7055875 0.0493341952,18.5864625 C0.0493341952,20.8767375 0.703012282,23.0034214 1.81303167,24.7777554 C-0.222003878,21.3423429 2.42970911,16.7743768 3.50272786,14.974875 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45339367,21.9086196 C3.66306399,20.6250589 4.36607628,19.0269 5.1307563,17.7181714 C5.73510019,16.6988732 7.15345831,14.5847732 11.0508597,9.43794643 L11.1618617,9.28693929 C11.8032062,8.43123214 12.9748933,7.02183214 14.6769231,4.88256429 L14.6769231,4.88256429 C15.5032708,3.80034643 16.674958,2.35319464 16.674958,2.35319464 L12.8268908,2.35319464 C12.4075501,2.88171964 12.0745443,3.29698929 11.6428701,3.85068214 C10.6191855,5.14682679 9.64483516,6.38005179 9.00349063,7.24834286 C8.96648998,7.29867857 8.88015514,7.39935 8.78148675,7.55035714 C7.97980608,8.59482321 5.2047576,12.1686589 3.51506141,14.9874589 C2.42970911,16.7869607 -0.222003878,21.3549268 1.82536522,24.7903393 C2.84904977,26.4136661 4.25507434,27.7475625 5.92010343,28.6410214 C3.99606981,27.5462196 3.00938591,24.6015804 3.45339367,21.9086196 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5821849,29.8490786 C16.0706141,29.8490786 21.5467098,25.5831268 21.5467098,18.4480393 C21.5467098,17.6175 21.4603749,16.7995446 21.2753717,16.0193411 C20.5600259,13.1376214 18.69766,10.3817411 16.5762896,7.44968571 C17.5506399,6.17870893 18.6236587,4.85739643 18.6236587,4.85739643 L14.6769231,4.85739643 L14.6769231,4.85739643 L14.6769231,4.85739643 C12.9748933,6.99666429 11.8032062,8.40606429 11.1618617,9.26177143 L11.0508597,9.41277857 C7.15345831,14.5596054 5.73510019,16.6737054 5.1307563,17.6930036 C4.36607628,18.9891482 3.66306399,20.5998911 3.45339367,21.8834518 C3.00938591,24.5764125 3.99606981,27.5210518 5.90776988,28.6032696 C7.31379444,29.3834732 8.90482224,29.8239107 10.5821849,29.8490786 L10.5821849,29.8490786 L10.5821849,29.8490786 Z M6.01877182,23.5822821 C6.01877182,21.3423429 7.47413058,19.3163304 8.54714932,17.8062589 C9.50916613,16.4597786 10.4341823,15.3020571 10.7178539,14.9622911 C10.7671881,14.8993714 10.8041888,14.8616196 10.8041888,14.8616196 C10.8041888,14.8616196 11.1371946,15.2643054 11.6305365,15.8935018 C11.8648739,16.1955161 12.136212,16.5478661 12.4198836,16.9379679 C12.629554,17.2148143 12.8392243,17.5168286 13.0612282,17.8188429 C13.0858953,17.8565946 13.1105624,17.8943464 13.1352295,17.9320982 C15.2936005,20.9019054 15.5896057,22.1854661 15.5896057,23.3557714 C15.5896057,25.8599732 13.7642405,28.5781018 10.7918552,28.5781018 C7.65913381,28.5529339 6.01877182,26.2878268 6.01877182,23.5822821 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.8041888,14.8490357 C10.8535229,14.7861161 10.8041888,14.8490357 10.8041888,14.8490357 L10.8041888,14.8490357 L10.8041888,14.8490357 C10.8041888,14.8490357 11.1371946,15.2517214 11.6305365,15.8809179 C11.8648739,16.1829321 12.136212,16.5352821 12.4198836,16.9253839 C12.629554,17.2022304 12.8392243,17.5042446 13.0612282,17.8062589 C13.0858953,17.8440107 13.1105624,17.8817625 13.1352295,17.9195143 C14.652256,19.9958625 15.2442663,21.2416714 15.4662702,22.2106339 L21.2753717,16.0948446 C21.2753717,16.0822607 21.2630381,16.0570929 21.2630381,16.0445089 C20.5476923,13.1627893 18.6853264,10.4069089 16.563956,7.47485357 C16.563956,7.47485357 16.563956,7.47485357 16.563956,7.47485357 C14.7632579,9.76512857 12.5062185,12.6468482 10.8041888,14.8490357 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    style: {
      mixBlendMode: "multiply"
    }
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSasLogoCropped);
export default __webpack_public_path__ + "static/media/SASLogo-cropped.1954018b.svg";
export { ForwardRef as ReactComponent };